import InputTypesEnum from '../../../Enums/InputTypesEnum';
import RolloverItem from '../../../Domain/RolloverItem';
import PlanningDetailsItemService from '../../../Services/PlanningDetailsItemService';

export default class RolloverWindowDescription {
  static titleForCreate = 'Rollover Between FW Periods';
  static titleForEdit = 'Rollover Between FW Periods';
  static itemType = RolloverItem;
  static serviceFunction = (item) => PlanningDetailsItemService.Rollover(item);

  static pagesInGeneralEditWizzard = [
    {
      label: 'Rollover',
      fields: [
        {
          fieldName: 'SourcePlanningDetailId',
          label: 'Source FW Period (will be rolled over) *',
          className: 'col-12',
          type: InputTypesEnum.Select,
          selectvalues: (item) => item.SourceOptions,
        },
        {
          fieldName: 'DistributionType',
          label: 'Distribution Type *',
          className: 'col-12',
          type: InputTypesEnum.Select,
          selectvalues: [
            { value: 'even', label: 'Distribute Evenly' },
            { value: 'perItem', label: 'Per Item' },
          ],
        },
        {
          fieldName: 'Volume',
          label: 'Volume to Roll Over (blank/0 = planned − completed) *',
          className: 'col-12',
          type: InputTypesEnum.Number,
          hide: (item) => item.DistributionType !== 'even',
          validityChecker: (field, editedItem) => {
            const raw = editedItem.Volume;
            if (raw === '' || raw === null || raw === undefined) return ''; // blank = auto (planned − completed)
            const val = parseInt(raw);
            if (isNaN(val) || val < 0) return 'Enter a positive number, or 0/blank to auto-fill (planned − completed)';
            return '';
          },
        },
        {
          fieldName: 'Items',
          valueField: 'rolloverValue',
          labelField: 'label',
          className: 'col-12',
          type: InputTypesEnum.Number,
          hide: (item) => item.DistributionType !== 'perItem',
          validityChecker: (field, editedItem, index) => {
            if (index === undefined) return '';
            if (editedItem.Items[index].PlanningDetailId === editedItem.SourcePlanningDetailId) return '';
            const val = parseInt(editedItem.Items[index].rolloverValue);
            if (isNaN(val) || val < 0) return 'Value must be >= 0';
            return '';
          },
        },
      ],
    },
  ];
}
